/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  const REGION_STORAGE_KEY = 'free_shipping_region';
  const REGIONS = ['west', 'east'];
  const REGION_CHANGE_EVENT = 'free-shipping:region:change';

  const readStoredRegion = () => {
    try {
      const stored = window.localStorage.getItem(REGION_STORAGE_KEY);
      return REGIONS.includes(stored) ? stored : null;
    } catch (e) {
      // Private browsing or a blocked storage partition — fall back to the default.
      return null;
    }
  };

  const writeStoredRegion = (region) => {
    try {
      window.localStorage.setItem(REGION_STORAGE_KEY, region);
    } catch (e) {
      // Nothing to do, the choice just will not survive a reload.
    }
  };

  class FreeShipping extends HTMLElement {
    constructor() {
      super();
      this.onRegionInput = this.onRegionInput.bind(this);
      this.onRegionChanged = this.onRegionChanged.bind(this);
    }

    connectedCallback() {
      this.total = parseInt(this.dataset.cartTotal, 10);
      this.amountText = this.querySelector('.free-shipping--text span');
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      this.regionInputs = Array.from(this.querySelectorAll('[data-free-shipping-region]'));

      // Only an explicit customer choice is persisted, so that a logged in
      // customer keeps getting the region derived from their default address
      // until they pick one themselves.
      this.region = readStoredRegion() || this.dataset.defaultRegion || 'west';

      this.regionInputs.forEach((input) => {
        input.checked = input.value === this.region;
        input.addEventListener('change', this.onRegionInput);
      });

      document.addEventListener(REGION_CHANGE_EVENT, this.onRegionChanged);

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener(REGION_CHANGE_EVENT, this.onRegionChanged);
    }

    onRegionInput(event) {
      if (!REGIONS.includes(event.target.value)) return;

      writeStoredRegion(event.target.value);
      dispatchCustomEvent(REGION_CHANGE_EVENT, { region: event.target.value });
    }

    onRegionChanged(event) {
      const region = event.detail && event.detail.region;
      if (!REGIONS.includes(region) || region === this.region) return;

      this.region = region;
      this.regionInputs.forEach((input) => {
        input.checked = input.value === region;
      });
      this.render();
    }

    get minimum() {
      const minimum = this.region === 'east' ? this.dataset.minimumEast : this.dataset.minimumWest;

      return Math.round(parseInt(minimum, 10) * (Shopify.currency.rate || 1));
    }

    render() {
      const minimum = this.minimum;
      let percentage = 1;

      if (this.total < minimum) {
        percentage = this.total / minimum;

        if (this.amountText) {
          const format = window.theme.settings.money_with_currency_format || '${{amount}}';
          this.amountText.innerHTML = formatMoney(minimum - this.total, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else if (this.remainingText && this.fullText) {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
